import { Icon } from '@iconify/react'
import type { MyAffiliateEmptyStateMessage } from '@/lib/my-affiliate'
import styles from './SouAfiliadoPage.module.css'

interface MyAffiliateEmptyStateProps {
  icon: string
  message: MyAffiliateEmptyStateMessage
}

export function MyAffiliateEmptyState({ icon, message }: MyAffiliateEmptyStateProps) {
  return (
    <div className={styles.centered}>
      <Icon icon={icon} style={{ fontSize: '2rem' }} />
      {message.lines.map((line) => (
        <p key={line}>{line}</p>
      ))}
      {message.authHint ? (
        <p className={styles.authHint}>
          <Icon icon="mdi:account-circle-outline" aria-hidden />
          {message.authHint}
        </p>
      ) : null}
    </div>
  )
}
